import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Image, Table, Spinner, Alert } from "react-bootstrap";

import { useEffect, useState, useRef, useMemo } from 'react';
import axios from 'axios';

import Layout from '../../components/Layout/Layout';
import ButtonSingpassLogin from '../../components/Form/ButtonSingpassLogin';

export default function Login() {


    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = (e) => {
        e.preventDefault();
        setShowPassword((prev) => !prev);
    };

    useEffect(() => {

        // document.title = "Dealer Login";

    }, []);


    return (
        <>
            <Layout>

                <Row className="justify-content-center">
                    <Col md={8}>
                        <div className="sign_in_main">
                            <div className="box mb-5">
                                <div className="box_title text-center">
                                    <p>Dealer Sign In</p>
                                </div>
                                <div className="sign_in_content">
                                    <Row>
                                        {/* <Col md={12}>
                                            <div className="form_main">
                                                <Form.Label>User ID</Form.Label>
                                                <Form.Control type="text" placeholder="Enter User ID" />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="form_main">
                                                <label className="form-label">Password</label>
                                                <div className="input_icon">
                                                    <Form.Control type={showPassword ? "text" : "password"} placeholder="Enter Password" />

                                                    <div className="icon">
                                                        <a type="button" className="btn btn-link p-0 m-0 toggle-password" onClick={handleTogglePassword}>
                                                            <i className={`fi ${showPassword ? "fi-rr-eye" : "fi-rr-eye-crossed"} toggle-eye-icon`}></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="text-center">
                                            <Button type="submit" size="lg" variant="" className="btn_primary w-100">Log In</Button>
                                        </Col>
                                        <Col xs={12} className="text-center">
                                            <div className="my-4">- OR -</div>
                                        </Col> */}

                                        <Col xs={12} className="text-center my-3">
                                            <ButtonSingpassLogin />
                                        </Col>

                                        {/* <Col md={12}>
                                            <div className="text-end already_account_text">
                                                <a href="#">Forgot Password?</a>
                                            </div>
                                        </Col> */}
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

            </Layout>
        </>
    );
}